// COPYRIGHT SMARTTRACK

/**
 * Requires
 */

// Babel
require('core-js/stable');
require('regenerator-runtime/runtime');

// Modules
const externalUserModule = require('../modules/external-user');
const navigationModule = require('../modules/navigation');
const inputModule = require('../modules/input');


/**
 * Action Handlers
 */

function createActionHandlers() {

	// Handle press form button
	$(document).keypress((e) => {
		if (e.keyCode === 13) {
			$('#formButton').click();
		}
	});

	// Handle click on action button
	$('#formButton').click(() => {
		externalUserModule.handleSendPasswordLink();
	});
}


/**
 * Input Handlers
 */

function createInputHandlers() {

	// Handle email focus
	$('#email').focus(() => {
		inputModule.removeBlockAlert();
	});

	// Handle email blur
	$('#email').blur(() => {
		inputModule.removeAlert('emailLabel', 'Your Email', true);
	});

	// Handle email key down
	$('#email').keydown(() => {
		inputModule.removeAlert('emailLabel', 'Your Email', true);
	});
}


/**
 * Init
 */

// Initialize navigation
navigationModule.initialize();

// Handle external user
externalUserModule.handleExternalUser(false, true);

// Create action handlers
createActionHandlers();

// Create input handlers
createInputHandlers();
